import { FunctionComponent, useEffect, useState } from 'react'
import DialogActions from '@/components/_custom/DialogActions/DialogActions'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import ReleaseDateField from '../components/ReleaseDateField/releaseDateField'
import styles from './scheduleOccasionalSlotDialog.module.scss'
import moment from 'moment-timezone'
import { calculateScheduleDateWithReleaseParameters } from '@/modules/helper/scheduledDateHelper.ts'
import { useDialog } from '@/hooks/useDialog/useDialog'
import OtherReservationSettings from '@/container/daycare/daycareProfile/merger/otherReservationSettings/otherReservationSettings'
import { useCurrentDaycareInfos } from '@/hooks/useCurrentDaycareInfos'

interface ScheduleOccasionalSlotProps {
    handleClose: () => void
    scheduleDate: string
    maxDate: string
    setScheduleDate: (date: string) => void
    createOccasionalSlot: () => void
}

export const ScheduleOccasionalSlot: FunctionComponent<ScheduleOccasionalSlotProps> = ({
    handleClose,
    scheduleDate,
    setScheduleDate,
    maxDate,
    createOccasionalSlot
}: ScheduleOccasionalSlotProps) => {
    const { t } = useTranslation()

    const { currentDaycare: daycare } = useCurrentDaycareInfos()

    const { dialog, openDialog, reopenTrigger } = useDialog({
        dialogTitle: t('otherReservationsSettings'),
        Component: OtherReservationSettings,
        props: (onClose) => ({ onClose, visibleSettings: ['release'] })
    })

    function handleConfirm(): void {
        handleClose()
        createOccasionalSlot()
    }

    const [defaultScheduledDate, setDefaultScheduledDate] = useState<string | undefined>(
        calculateScheduleDateWithReleaseParameters(maxDate, daycare.releaseParameters)
    )

    useEffect(() => {
        const newDefaultDate: string | undefined = calculateScheduleDateWithReleaseParameters(
            maxDate,
            daycare.releaseParameters
        )
        if (newDefaultDate !== defaultScheduledDate || reopenTrigger === 0) {
            setDefaultScheduledDate(newDefaultDate)
            if (newDefaultDate) {
                setScheduleDate(newDefaultDate)
            }
        }
    }, [daycare, reopenTrigger])

    return (
        <>
            <div className={styles.Input}>
                <ReleaseDateField
                    value={scheduleDate}
                    onChange={setScheduleDate}
                    minDate={moment().add(1, 'hour').startOf('hour').format('DD-MM-YYYY HH:mm')}
                    maxDate={`${maxDate} 00:00`}
                    className={styles.UserInput}
                />
            </div>

            <div className={styles.TextContainer} onClick={openDialog}>
                <p className={styles.Link}>
                    {defaultScheduledDate ? t('modifyDefaultReleaseDate') : t('addDefaultReleaseDate')}
                </p>
            </div>
            <DialogActions>
                <ButtonTextIcon type={'close'} onClick={handleClose} nowrap />
                <ButtonTextIcon type={'confirm'} onClick={handleConfirm} nowrap />
            </DialogActions>
            {dialog}
        </>
    )
}
export default ScheduleOccasionalSlot
